// extracted by mini-css-extract-plugin
var _1 = "ProfileActionsWidgetSkeleton-moduleProfileActionsWidgetSkeleton__MIBED";
var _2 = "ProfileActionsWidgetSkeleton-moduleaction__FK8In Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "ProfileActionsWidgetSkeleton", _2 as "action" }
